import http from "../../http-common";

const getGeneral = async (query) => {
  return await http
    .get("/admin/financial/general", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getPayments = async (query) => {
  return await http
    .get("/admin/financial/payment", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getTickets = async (query) => {
  return await http
    .get("/admin/financial/ticket", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};
const getPaymentHighlight = async (query) => {
  return await http
    .get("/admin/financial/payment/highlight", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getChargebacks = async (query) => {
  return await http
    .get("/admin/financial/chargeback", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getPayment = async (id) => {
  return await http
    .get(`/admin/financial/payment/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getEntries = async (query) => {
  return await http
    .get("/admin/financial/entry", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const reportChargeback = async (id, options) => {
  return await http
    .put(`/admin/financial/payment/${id}/chargeback`, options)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getReportByMonth = async (platformId, year) => {
  return await http
    .get("/admin/financial/payment/by-month", { params: { platformId, year } })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getReportByDay = async (platformId, month) => {
  return await http
    .get("/admin/financial/payment/by-day", { params: { platformId, month } })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getGeneral,
  getTickets,
  getPayments,
  getEntries,
  getPaymentHighlight,
  getChargebacks,
  getPayment,
  reportChargeback,
  getReportByMonth,
  getReportByDay,
};
